import React from 'react'
import { useRecordContext } from 'react-admin'

export const ManualTitle = () => {
  const record = useRecordContext()
  const name = record ? (record.name as string) : ''

  return <span>Manual{name && `: ${name}`}</span>
}
